import React from 'react'
import { ElementProps } from './element.props'

export const Element = ({
  tag,
  className,
  children,
}: ElementProps): JSX.Element =>
  React.createElement(
    tag || 'div',
    {
      className: className,
    },
    [...children]
  )
